import b_ from 'b_';
import { Button, Modal, Text, useAppContext } from 'platform-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { getAuthPath } from 'utils/get-auth-path';

import { actions } from './actions';
import { getShouldShowModal } from './selectors';

import './authorization-modal.scss';

const b = b_.with('authorization-modal');

export const AuthorizationModal = () => {
    const shouldShowModal = useSelector(getShouldShowModal);
    const dispatch = useDispatch();
    const { search, pathname } = useLocation();

    const { basePath, prefix, staticUrls } = useAppContext();

    const handleModalClose = () => dispatch(actions.closeModal());

    const handleRedirectToPassport = () => {
        const passportUrl = getAuthPath({
            retpath: `${basePath}${prefix}${staticUrls.home}${search}`,
            backpath: `${basePath}${prefix}${pathname}${search}`,
        });

        if (window?.location) {
            window.location.href = passportUrl;
        }
    };

    return (
        <Modal hasClose mix={b('wrapper')} onRequestClose={handleModalClose} opened={shouldShowModal}>
            <div className={b()}>
                <Modal.Content>
                    <Text id="authorizationModal.decscription" />
                </Modal.Content>
                <Modal.Footer>
                    <div className={b('buttons')}>
                        <Button className={b('button')} onClick={handleRedirectToPassport} view={Button.VIEW.ACTION}>
                            <Text id="authorizationModal.continue" />
                        </Button>
                        <Button className={b('button')} onClick={handleModalClose} view={Button.VIEW.SECONDARY}>
                            <Text id="authorizationModal.cancel" />
                        </Button>
                    </div>
                </Modal.Footer>
            </div>
        </Modal>
    );
};
